import { withStyles } from '@material-ui/core/styles';
import styles from './Avatar.styles';
import Avatar from './Avatar';

export default withStyles(styles)(Avatar);
